'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { NotificationTypes } from 'AdsUI/lib/Constants';
import { postNotification } from 'ReduxMessenger/actions/NotificationActions';
let notificationId = Math.floor(Math.random() * 99999999);
export default function (opts) {
  const {
    dispatch,
    action,
    actionNotificationHandlers,
    getState
  } = opts;
  const {
    type
  } = action;
  let notification;

  if (actionNotificationHandlers && actionNotificationHandlers[type]) {
    notification = actionNotificationHandlers[type](action, getState);
  } else if (type.indexOf('_FAILED') > -1) {
    notification = actionNotificationHandlers.genericFailure(action);
  }

  if (notification) {
    const {
      type: notificationType
    } = notification,
          notificationProps = _objectWithoutPropertiesLoose(notification, ["type"]);

    dispatch(postNotification(Object.assign({
      id: ++notificationId
    }, notificationProps, {
      type: notificationType === NotificationTypes.ERROR ? 'danger' : notificationType
    })));
  }
}